import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class Section174Service {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  getSectionDetails(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData) return of({ callSuccess: '0', errorMessage: 'Row data is required.' });
    const checked = data.rowData.SECTION_174 === 1;
    const paramsObj: any = {
      action_code: 'mfnpur',
      scenario: globalService?.globalParams?.scenario,
      jcd_key: globalService?.globalParams?.jcd_key,
      tax_year: data.rowData.TAX_YEAR,
      combination_key: data.rowData.COMBINATION_KEY,
      checkedFalg: checked,
      jsonObj: JSON.stringify(data.rowData)
    };
    return this.jsonObjectFactoryService.getJSONObj6(
      `${baseUrl}/loadJsonObject`,
      paramsObj,
      globalService,
      filterParams
    );
  }
}
